"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const query_1 = require("@reduxjs/toolkit/query");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const consumer_applications_v2_api_1 = require("consumer-applications-v2-api");
const hooks_1 = require("hooks");
const actions_1 = require("../actions");
const reducer_1 = require("../reducer");
const ImprintCashFlowModal_1 = __importDefault(require("./ImprintCashFlowModal"));
function ImprintCashFlowModalShell({ isCashFlowModalOpen, setIsCashFlowModalOpen, offer, setCashFlowBrowserResponse, cashFlowBrowserResponse, }) {
    const dispatch = (0, react_redux_1.useDispatch)();
    const prequalification = (0, react_redux_1.useSelector)(reducer_1.selectors.prequalification);
    const { setNewTab, closeNewTab } = (0, hooks_1.useNewTab)(() => {
        setCashFlowBrowserResponse('SUCCESS');
        setAwaitingCashFlowResponse(false);
        setShouldPoll(true);
    });
    const [awaitingCashFlowResponse, setAwaitingCashFlowResponse] = (0, react_1.useState)(false);
    const [shouldPoll, setShouldPoll] = (0, react_1.useState)(false);
    const { data, isError: isErrorPolling } = (0, consumer_applications_v2_api_1.useGetConsumerApplicationsV2CreditApplicationsApplicationIdQuery)(shouldPoll
        ? {
            applicationId: prequalification.applicationId,
        }
        : query_1.skipToken, { pollingInterval: 3000, skipPollingIfUnfocused: true });
    const handleLinkBankAccount = () => {
        setNewTab(window.open(offer.cashflowUnderwriting?.url, '_blank', 'width=600,height=1000'));
        setAwaitingCashFlowResponse(true);
    };
    const handleContinueWithCurrentOffer = () => {
        setIsCashFlowModalOpen(false);
    };
    const handleRefreshCurrentOffer = () => {
        setCashFlowBrowserResponse('SUCCESS');
        setShouldPoll(true);
    };
    (0, react_1.useEffect)(() => {
        const cashflowUnderwriting = data?.offers?.find((o) => o.offerId === offer.offerId)?.cashflowUnderwriting;
        if (data &&
            cashflowUnderwriting &&
            cashflowUnderwriting.status !== 'created') {
            dispatch((0, actions_1.setPrequalification)(data));
            setIsCashFlowModalOpen(false);
            setShouldPoll(false);
        }
        if (isErrorPolling) {
            setIsCashFlowModalOpen(false);
            setShouldPoll(false);
        }
    }, [data, isErrorPolling]);
    (0, react_1.useEffect)(() => {
        if (cashFlowBrowserResponse === 'SUCCESS') {
            setShouldPoll(true);
        }
        if (cashFlowBrowserResponse === 'INTERNAL_ERROR') {
            setIsCashFlowModalOpen(false);
        }
    }, [cashFlowBrowserResponse, offer]);
    (0, react_1.useEffect)(() => {
        const handler = async (event) => {
            if (offer.cashflowUnderwriting?.url.includes(event.origin)) {
                setCashFlowBrowserResponse(event.data?.data?.status);
                closeNewTab();
            }
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, [closeNewTab, offer.cashflowUnderwriting?.url]);
    return ((0, jsx_runtime_1.jsx)(ImprintCashFlowModal_1.default, { isOpen: isCashFlowModalOpen, setIsOpen: setIsCashFlowModalOpen, handleLinkBankAccount: handleLinkBankAccount, handleContinueWithCurrentOffer: handleContinueWithCurrentOffer, handleRefreshCurrentOffer: handleRefreshCurrentOffer, isRefreshing: shouldPoll, awaitingCashFlowResponse: awaitingCashFlowResponse || shouldPoll, hideModalClose: awaitingCashFlowResponse, amount: offer.amount }));
}
exports.default = ImprintCashFlowModalShell;
